/* tokamoka v2 — sepet çekmecesi önerisi: "Setini tamamla" ya da "Yanına bir mini".
   Çekmece dosyasına dokunmaz; öneri bloğu çekmece her yenilendiğinde tarayıcıda yeniden eklenir.
   Veri: snippets/tk-upsell-data.liquid. Ekleme: assets/tk-bundle.js (window.tkBundle). */
(function () {
  'use strict';
  var B = window.tkBundle;
  if (!B) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var money = B.money, track = B.track, props = B.props, busy = B.busy, friendly = B.friendly, addItems = B.addItems;
  function $(sel, el) { return (el || document).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }

  /* ---------- Sepet çekmecesi: setini tamamla / yanına bir mini ---------- */
  var DATA = null;
  (function () {
    var el = document.getElementById('tk-upsell-data');
    if (!el) return;
    try { DATA = JSON.parse(el.textContent); } catch (e) { DATA = null; }
  })();

  var pendingCart = null;
  function fetchCart() {
    if (pendingCart) return pendingCart;
    pendingCart = fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; })
      .then(function (c) { pendingCart = null; return c; });
    return pendingCart;
  }

  function pickUpsell(cart) {
    if (!DATA || !cart || !cart.items || !cart.items.length) return null;
    var byVariant = {}, byHandle = {};
    cart.items.forEach(function (it) { byVariant[it.variant_id] = true; byHandle[it.handle] = true; });
    function present(it) { return it.pin ? !!byVariant[it.vid] : !!byHandle[it.h]; }
    var best = null;
    (DATA.sets || []).forEach(function (s) {
      var have = 0, missing = [], blocked = false;
      (s.items || []).forEach(function (it) {
        if (present(it)) { have++; return; }
        if (it.a) missing.push(it); else blocked = true;
      });
      if (have < 1 || !missing.length || blocked) return;
      var score = have * 100 + Math.round(100 * have / s.items.length);
      if (!best || score > best.score) best = { kind: 'set', set: s, items: missing, score: score };
    });
    if (best) return best;
    var minis = (DATA.minis || []).filter(function (m) { return !byHandle[m.h]; });
    if (!minis.length) return null;
    var twin = minis.filter(function (m) { return byHandle[m.h.replace(/^mini-/, '')]; });
    var rest = minis.filter(function (m) { return twin.indexOf(m) === -1; });
    return { kind: 'mini', items: twin.concat(rest).slice(0, 3) };
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function buildUpsell(sel) {
    var box = el('div', 'tk-upsell');
    box.setAttribute('data-tk-upsell', '');
    var src = 'sepet-oneri:' + (sel.kind === 'set' ? sel.set.id : 'mini');
    var head = el('div', 'tk-upsell__head');
    if (sel.kind === 'set') {
      head.appendChild(el('p', 'tk-upsell__title', 'Setini tamamla'));
      head.appendChild(el('p', 'tk-upsell__sub', sel.set.title + ' · ' + (sel.items.length === 1 ? 'bir karakter kaldı' : sel.items.length + ' karakter kaldı')));
    } else {
      head.appendChild(el('p', 'tk-upsell__title', 'Yanına bir mini'));
      head.appendChild(el('p', 'tk-upsell__sub', 'Küçük boy; ön tutam ve ince saç için.'));
    }
    box.appendChild(head);
    var list = el('div', 'tk-upsell__list');
    sel.items.slice(0, 3).forEach(function (it) {
      var card = el('div', 'tk-upsell__item');
      var pic = el('span', 'tk-upsell__img');
      if (it.img) {
        var img = document.createElement('img');
        img.src = it.img; img.alt = ''; img.loading = 'lazy';
        if (it.cut) {
          /* dekupe: maskeli fotoğraf + silüet gölgesi (snippets/tk-cut.liquid) */
          pic.classList.add('has-cut');
          pic.setAttribute('style', it.cut);
          img.className = 'tk-cutimg';
          var wrap = el('span', 'tk-cutw');
          wrap.appendChild(img);
          pic.appendChild(wrap);
        } else {
          img.width = 80; img.height = 80;
          pic.appendChild(img);
        }
      }
      card.appendChild(pic);
      var name = (it.t || '') + (it.vt ? ' · ' + it.vt : '');
      card.appendChild(el('span', 'tk-upsell__name', name));
      card.appendChild(el('span', 'tk-upsell__price', money(it.p)));
      var add = el('button', 'tk-upsell__add', '+ Ekle');
      add.type = 'button';
      add.setAttribute('aria-label', name + ' ekle, ' + money(it.p));
      add.addEventListener('click', function () { addFromUpsell([it], src, add); });
      card.appendChild(add);
      list.appendChild(card);
    });
    box.appendChild(list);
    if (sel.kind === 'set' && sel.items.length > 1) {
      var sum = sel.items.reduce(function (s, it) { return s + (it.p || 0); }, 0);
      var words = { 2: 'İkisini', 3: 'Üçünü', 4: 'Dördünü' };
      var all = el('button', 'tk-btn tk-btn--cocoa tk-upsell__all');
      all.type = 'button';
      var lab = el('span', 'tk-btn__label', (words[sel.items.length] || 'Hepsini') + ' birden ekle · ' + money(sum));
      lab.setAttribute('data-tk-label', '');
      all.appendChild(lab);
      var sp = el('span', 'tk-spin'); sp.setAttribute('aria-hidden', 'true'); all.appendChild(sp);
      all.addEventListener('click', function () { addFromUpsell(sel.items, src, all); });
      box.appendChild(all);
    }
    box.appendChild(el('p', 'tk-upsell__msg'));
    return box;
  }

  function addFromUpsell(items, src, btn) {
    busy(btn, true);
    addItems(items.map(function (it) { return { id: it.vid, quantity: 1, properties: props(src) }; }), { source: 'sepet-oneri', open: false })
      .then(function () { track('tk_sepet_oneri_ekle', { kaynak: src, adet: items.length }); })
      .catch(function (e) {
        var box = btn.closest('[data-tk-upsell]');
        var m = box && $('.tk-upsell__msg', box);
        if (m) m.textContent = friendly(e);
        busy(btn, false); btn.disabled = false;
      });
  }

  var upsellTimer = null;
  function ensureUpsell(force) {
    if (!DATA) return;
    var body = document.getElementById('MinimogCartDrawerBody');
    if (!body) return;
    if (!force && body.querySelector('[data-tk-upsell]')) return;
    fetchCart().then(function (cart) {
      var b = document.getElementById('MinimogCartDrawerBody');
      if (!b) return;
      var old = b.querySelector('[data-tk-upsell]');
      var sel = pickUpsell(cart);
      if (!sel) { if (old) old.parentNode.removeChild(old); return; }
      var box = buildUpsell(sel);
      if (old) old.parentNode.replaceChild(box, old); else b.appendChild(box);
    });
  }
  function scheduleUpsell(force) {
    clearTimeout(upsellTimer);
    upsellTimer = setTimeout(function () { ensureUpsell(force); }, 80);
  }

  function initDrawerUpsell() {
    var drawer = document.getElementById('MinimogCartDrawer');
    if (!drawer || !DATA) return;
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        var body = document.getElementById('MinimogCartDrawerBody');
        if (body && !body.querySelector('[data-tk-upsell]') && drawer.classList.contains('m-cart-drawer--active')) scheduleUpsell(false);
      }).observe(drawer, { childList: true, subtree: true });
    }
    document.addEventListener('cart:updated', function () { scheduleUpsell(true); });
    document.addEventListener('tk:cart:added', function () { scheduleUpsell(true); });
    var bus = window.MinimogEvents, theme = window.MinimogTheme;
    if (bus && theme && theme.pubSubEvents && theme.pubSubEvents.openCartDrawer) {
      bus.subscribe(theme.pubSubEvents.openCartDrawer, function () { scheduleUpsell(true); });
    } else {
      $$('.m-cart-icon-bubble').forEach(function (a) { a.addEventListener('click', function () { scheduleUpsell(true); }); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDrawerUpsell);
  else initDrawerUpsell();
})();
